import { ProductAdvancedTab } from './ProductAdvancedTab';

export default ProductAdvancedTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductAdvancedTab/index.ts